export default {
  // "hostLink": "https://localhost:5001"
  "hostLink": "https://lp3.polskieradio.pl/"
}
